
(function () {
  'use strict';

  var HEADING_ID = 'dialog-heading';
  var TRIGGER = 'button.account-button';

  var defaultHeading = null;

  function resolve() {
    var host = document.querySelector('shopify-account');
    if (!host || !host.shadowRoot) return null;
    var trigger = host.shadowRoot.querySelector(TRIGGER);
    if (!trigger) return null;
    return { host: host, trigger: trigger, heading: host.shadowRoot.getElementById(HEADING_ID) };
  }

  function remember(heading) {
    if (defaultHeading === null && heading && heading.textContent) {
      defaultHeading = heading.textContent;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var el = event.target;
      if (!el || el.tagName !== 'SHOPIFY-ACCOUNT') return;
      var parts = resolve();
      if (!parts || !parts.heading) return;
      remember(parts.heading);
      if (defaultHeading === null) return;

      if (typeof event.composedPath !== 'function') {
        parts.heading.textContent = defaultHeading;
        return;
      }
      var path = event.composedPath();
      for (var i = 0; i < path.length; i++) {
        if (path[i] === parts.trigger) {
          parts.heading.textContent = defaultHeading;
          return;
        }
      }
    },
    true
  );

  window.BNAccount = {
    open: function (heading) {
      try {
        var parts = resolve();
        if (!parts) return false;

        remember(parts.heading);
        parts.trigger.click();

        if (parts.heading && heading) parts.heading.textContent = heading;
        return true;
      } catch (e) {
        return false;
      }
    }
  };
})();
